import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  InputAdornment,
  Button,
  Chip,
  Avatar,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Grid
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterAlt as FilterIcon,
  Storefront as StorefrontIcon,
  Restaurant as RestaurantIcon,
  CalendarMonth as CalendarIcon,
  Visibility as VisibilityIcon,
  Download as DownloadIcon,
  PictureAsPdf as PdfIcon,
  TakeoutDining as TakeawayIcon,
  DeliveryDining as DeliveryIcon,
  RestaurantMenu as DineInIcon,
  Kitchen as CateringIcon,
  Clear
} from '@mui/icons-material';

import outletService from '../services/outletService';
import { getOrdersReportData, downloadOrdersReportPDF } from '../services/reportService';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const statusColors = {
  Approved: 'success',
  Pending: 'warning',
  Delivered: 'info',
  Confirmed: 'secondary',
  Cancelled: 'error'
};

const orderTypeColors = {
  'takeaway': 'warning',
  'delivery': 'primary',
  'dine-in': 'success',
  'catering': 'secondary'
};

const orderTypeIcons = {
  'takeaway': <TakeawayIcon fontSize="small" />,
  'delivery': <DeliveryIcon fontSize="small" />,
  'dine-in': <DineInIcon fontSize="small" />,
  'catering': <CateringIcon fontSize="small" />
};

const formatOrderType = (type) => {
  if (type === 'takeaway') return 'Takeaway';
  if (type === 'delivery') return 'Delivery';
  if (type === 'dine-in') return 'Dine-in';
  if (type === 'catering') return 'Catering';
  return type.charAt(0).toUpperCase() + type.slice(1);
};

const OrderReportManagement = () => {

 
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [timeRange, setTimeRange] = useState("all");
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("all")
  const [orderType, setOrderType] = useState('All Types');
  const [status, setStatus] = useState('All Statuses');
  const [search, setSearch] = useState('');
  const [ordersData, setOrdersData] = useState({
    pagination: {
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      has_next: false,
      has_prev: false
    },
    data: []
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [openSelect, setOpenSelect] = useState(null);
  const [filterClear,setFilterClear] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      setOpenSelect(null);
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  const handleChangePage = (event, newPage) => {

    const backendPage = newPage + 1;
    setPage(newPage);

    handleDataChange(selectedOutlet, timeRange, orderType, status, backendPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    handleDataChange(selectedOutlet, timeRange, orderType, status, 1, newRowsPerPage);
  };
   const clearFilters= () => {
    setPage(0)
    setRowsPerPage(10);
    setTimeRange("all");
    setOrderType("All Types");
    setStatus("All Statuses")
    setSelectedOutlet("all");
    setFilterClear(!filterClear)
    
  }

  useEffect(() => {
    let admin_check = JSON.parse(localStorage.getItem('admin_outlet_id'))
    async function getOutlets() {
      try {
        const response = await outletService.getOutlets()
        setOutlets(response)
        // Initial fetch with default pagination
        if (admin_check) {
          const orderDataResponse = await getOrdersReportData(admin_check, timeRange, "all", "all", 1, rowsPerPage)
          setSelectedOutlet(admin_check)
          setOrdersData(orderDataResponse)
        }
        else {
          const orderDataResponse = await getOrdersReportData(selectedOutlet, timeRange, "all", "all", 1, rowsPerPage)
          setOrdersData(orderDataResponse)
        }


      }
      catch (error) {
        // console.error("Error While Getting Outlets => ", error)
      }
    }
    getOutlets()
  }, [filterClear])

  const handleDataChange = async (outlet_id, time, orderTypeFilter, statusFilter, page = 1, limit = rowsPerPage) => {
    // Convert UI values to API values
    const apiOrderType = orderTypeFilter === 'All Types' ? 'all' : orderTypeFilter.toLowerCase();
    const apiStatus = statusFilter === 'All Statuses' ? 'all' : statusFilter.toLowerCase();

    if (time === "custom") {
      try {
        let dateFilterParam = time;
        // Format dates as YYYY-MM-DD
        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];
        dateFilterParam = `custom:${startDateStr}:${endDateStr}`;
        const orderDataResponse = await getOrdersReportData(outlet_id, dateFilterParam, apiOrderType, apiStatus, page, limit)
        // console.log("=> ", orderDataResponse)
        setOrdersData(orderDataResponse)
        setPage(orderDataResponse.pagination.page - 1);
      }
      catch (error) {
        // console.error("Error Happens while Getting Orders Data", error)
      }
    } else {
      try {
        const orderDataResponse = await getOrdersReportData(outlet_id, time, apiOrderType, apiStatus, page, limit)
        // console.log("Order Response => ", orderDataResponse);
        setOrdersData(orderDataResponse)
        setPage(orderDataResponse.pagination.page - 1);
      }
      catch (error) {
        // console.error("Error Happens while Getting Orders Data", error)
      }
    }
  }

  const handleCustomDateChange = () => {
    // console.log("s ", startDate + " - " + endDate);
    handleDataChange(selectedOutlet, "custom", orderType, status, 1, rowsPerPage);
  }

  const downloadOrdersReport = async (outlet, time) => {
    if (outlet === "all") outlet = null
    if (time === "all") time = null

    // Convert UI values to API values for download
    const apiOrderType = orderType === 'All Types' ? null : orderType.toLowerCase();
    const apiStatus = status === 'All Statuses' ? null : status.toLowerCase();

    if (timeRange === "custom") {
      let dateFilterParam = time;
      // Format dates as YYYY-MM-DD
      const startDateStr = startDate.toISOString().split('T')[0];
      const endDateStr = endDate.toISOString().split('T')[0];
      dateFilterParam = `custom:${startDateStr}:${endDateStr}`;
      try {
        const response = await downloadOrdersReportPDF(outlet, dateFilterParam, apiOrderType, apiStatus)
      }
      catch (error) {
        // console.error("Error Happened => ", error)
      }
    }
    else {
      try {
        const response = await downloadOrdersReportPDF(outlet, time, apiOrderType, apiStatus)
      }
      catch (error) {
        // console.error("Error Happened => ", error)
      }
    }
  }

  // Filter orders locally based on search, orderType, and status filters
  const filteredOrders = ordersData.data.filter(order => {
    let backendOrderType;
    if (order.type === "Dine In") {
      backendOrderType = "dine_in"
    }
    else {
      backendOrderType = order.type
    }
    return (
      (search === '' ||
        order.order_number.toLowerCase().includes(search.toLowerCase()) ||
        order.customer_name.toLowerCase().includes(search.toLowerCase()) ||
        order.outlet.toLowerCase().includes(search.toLowerCase())) &&
      (orderType === 'All Types' || backendOrderType === orderType.toLowerCase())
      // (status === 'All Statuses' || order.status === status.toLowerCase())
    );
  });

  // Use filtered orders for display if search/filters are applied locally
  // Otherwise use the full dataset from paginated response
  const displayOrders = search || orderType !== 'All Types' || status !== 'All Statuses'
    ? filteredOrders
    : ordersData.data;

  // console.log("Display Orders => ", displayOrders)

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box sx={{ width: '100%', p: 3 }}>
          {/* Header Section */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Orders Report
            </Typography>
            <Typography color="text.secondary" variant="body1">
              View and manage all restaurant orders across outlets
            </Typography>
          </Box>

          {/* Actions and Filters */}
          <Box sx={{ mb: 3 }}>
            <Grid container spacing={2} alignItems="flex-end" sx={{ mt: 2 }}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  placeholder="Search by Order ID, Customer Name, or Outlet"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Time Range</InputLabel>
                  <Select
                    open={openSelect === "timeRange"}
                    onOpen={() => setOpenSelect("timeRange")}
                    onClose={() => setOpenSelect(null)}
                    value={timeRange}
                    label="Time Range"
                    onChange={(e) => {
                      setTimeRange(e.target.value)
                      handleDataChange(selectedOutlet, e.target.value, orderType, status, 1, rowsPerPage)
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <CalendarIcon />
                      </InputAdornment>
                    }
                    MenuProps={{
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                          maxHeight: 200,
                        },
                      },
                    }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="yesterday">Yesterday</MenuItem>
                    <MenuItem value="last_7_days">Last 7 Days</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Outlet</InputLabel>
                  <Select
                    open={openSelect === "outlet"}
                    onOpen={() => setOpenSelect("outlet")}
                    onClose={() => setOpenSelect(null)}
                    disabled={JSON.parse(localStorage.getItem('admin_outlet_id')) ? true : false}
                    label="Outlet"
                    value={selectedOutlet}
                    onChange={(e) => {
                      setSelectedOutlet(e.target.value)
                      handleDataChange(e.target.value, timeRange, orderType, status, 1, rowsPerPage)
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <StorefrontIcon />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="all">All Outlets</MenuItem>
                    {outlets.map((outlet) => {
                      return (
                        <MenuItem key={outlet.id} value={outlet.id}>{outlet.name}</MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Order Type</InputLabel>
                  <Select
                    open={openSelect === "orderType"}
                    onOpen={() => setOpenSelect("orderType")}
                    onClose={() => setOpenSelect(null)}
                    label="Order Type"
                    value={orderType}
                    onChange={(e) => {
                      const newOrderType = e.target.value;
                      setOrderType(newOrderType)
                      handleDataChange(selectedOutlet, timeRange, newOrderType, status, 1, rowsPerPage)
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <RestaurantIcon />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="All Types">All Types</MenuItem>
                    <MenuItem value="Dine_in">Dine-in</MenuItem>
                    <MenuItem value="Takeaway">Takeaway</MenuItem>
                    <MenuItem value="Delivery">Delivery</MenuItem>
                    {/* <MenuItem value="Catering">Catering</MenuItem> */}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    open={openSelect === "status"}
                    onOpen={() => setOpenSelect("status")}
                    onClose={() => setOpenSelect(null)}
                    label="Status"
                    value={status}
                    onChange={(e) => {
                      const newStatus = e.target.value;
                      setStatus(newStatus)
                      handleDataChange(selectedOutlet, timeRange, orderType, newStatus, 1, rowsPerPage)
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <FilterIcon />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="All Statuses">All Statuses</MenuItem>
                    <MenuItem value="Approved">Approved</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Delivered">Delivered</MenuItem>
                    <MenuItem value="Cancelled">Cancelled</MenuItem>
                    <MenuItem value="Without_Cancel">Without Cancel</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>


          {/* Export Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            {/* Custom Date Range Selector - Left side */}
            {timeRange === 'custom' && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DatePicker
                  value={startDate}
                  onChange={(newDate) => setStartDate(newDate)}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{
                        width: '140px',
                        '& .MuiInputBase-root': {
                          height: '32px',
                          fontSize: '0.75rem'
                        },
                        '& .MuiInputBase-input': {
                          padding: '6px 8px',
                          fontSize: '0.75rem'
                        }
                      }}
                    />
                  )}
                />

                <Typography variant="body2" sx={{ color: '#555', whiteSpace: 'nowrap', px: 0.5 }}>
                  to
                </Typography>

                <DatePicker
                  value={endDate}
                  onChange={(newDate) => setEndDate(newDate)}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{
                        width: '140px',
                        '& .MuiInputBase-root': {
                          height: '32px',
                          fontSize: '0.75rem'
                        },
                        '& .MuiInputBase-input': {
                          padding: '6px 8px',
                          fontSize: '0.75rem'
                        }
                      }}
                    />
                  )}
                />

                <Button
                  variant="contained"
                  size="small"
                  onClick={handleCustomDateChange}
                  sx={{
                    height: '32px',
                    minWidth: '60px',
                    fontSize: '0.75rem',
                    backgroundColor: '#1976d2',
                    '&:hover': {
                      backgroundColor: '#1565c0'
                    },
                    ml: 1
                  }}
                >
                  Apply
                </Button>
              </Box>
            )}

            {/* Download Report Button - Always on the right side */}
            <Box sx={{display:'flex',gap:1}}>
              <Button
                variant="contained"
                startIcon={<PdfIcon />}
                onClick={() => downloadOrdersReport(selectedOutlet, timeRange)}
                sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' } }}
              >
                Download Report
              </Button>
              <Button
                variant="outlined"
                startIcon={<Clear />}
                onClick={() => clearFilters()}
              >
                Clear Filters
              </Button>
            </Box>

          </Box>

          {/* Orders Table */}
          <Paper sx={{ width: '100%', overflow: 'hidden', mb: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: 'grey.50' }}>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Order ID</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Type</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Outlet</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Customer</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Date & Time</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Total</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2" fontWeight="bold">Status</Typography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayOrders.map((order, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ fontWeight: 'bold', color: '#333' }}>{order.order_number}</TableCell>
                      <TableCell>
                        <Chip
                          icon={orderTypeIcons[order.type.toLowerCase()] || <RestaurantIcon fontSize="small" />}
                          label={formatOrderType(order.type)}
                          color={orderTypeColors[order.type.toLowerCase()] || 'default'}
                          size="small"
                          variant="outlined"
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell align="left" sx={{ color: '#555' }}>{order.outlet}</TableCell>
                      <TableCell align="left" sx={{ color: '#2e7d32', fontWeight: 500 }}>{order.customer_name}</TableCell>
                      <TableCell align="left" sx={{ color: '#f44336', fontWeight: 500 }}>
                        {new Date(order.date).toLocaleDateString('en-GB')} {new Date(order.date).toLocaleTimeString()}
                      </TableCell>
                      <TableCell align="left" sx={{ color: '#0288d1', fontWeight: 500 }}>S${order.total_cost}</TableCell>
                      <TableCell align="left">
                        <Chip
                          label={order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                          color={statusColors[order.status.charAt(0).toUpperCase() + order.status.slice(1)] || 'default'}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  {displayOrders.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                        <Typography color="text.secondary">
                          No orders found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Table Pagination */}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={
                search || orderType !== 'All Types' || status !== 'All Statuses'
                  ? filteredOrders.length // Use filtered count for local filtering
                  : ordersData.pagination.total_records // Use total records from backend for paginated data
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelDisplayedRows={({ from, to, count }) =>
                search || orderType !== 'All Types' || status !== 'All Statuses'
                  ? `${from}-${to} of ${count}`
                  : `${from}-${to} of ${ordersData.pagination.total_records}`
              }
            />
          </Paper>
        </Box>
      </LocalizationProvider>
    </>
  );
};

export default OrderReportManagement;